import { Box, VStack } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';

import IndicatorHeader from '@/components/indicators/IndicatorHeader';
import CollectePeriodTable from '@/components/indicators/collecte/CollectePeriodTable';

export const Route = createFileRoute('/_layout/$slug/indicators/collecte/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <VStack maxW="100%" maxH="100vh" overflow={'hidden'} flexGrow={1}>
      <IndicatorHeader />
      <Box p={'1rem 1rem'} w={'full'}>
        <Box p={'3px'} bg={'#F1F7FA'} justifyContent="center" w={'100%'}>
          <CollectePeriodTable />
        </Box>
      </Box>
    </VStack>
  );
}
